import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NewHeader from "../../../Home/NewHeader";
import Breadcrumb from "../../ProfileCommon/Breadcrumb";
import privacyPolicySections from "./../../../../contanst/privacyPolicySections.json";
import LoadingCommon from "../../../../components/common/LoadingStatus/LoadingCommon";
const DataProtectionPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="flex overflow-hidden flex-col mx-auto w-full bg-white max-w-[480px]">
      <LoadingCommon statusLoading={isLoading} />
      <div className="flex flex-col w-full min-h-[912px]">
        <div className="fixed top-0 left-0 w-full z-50">
          <NewHeader />
        </div>
        <div className="h-[30px]"></div>
        <div className="flex flex-col flex-1 justify-start gap-3 p-4 w-full px-[30px]">
          <Breadcrumb
            className={"text-[#333333]"}
            breadCrumbTiltle={t("support.dataProtectionPolicy")}
            // onClickBack={() => navigate("/profile/support")}
            onClickBack={() => navigate(-1)}
          />
          {privacyPolicySections.map((item, index) => (
            <div key={index} className="mb-2">
              <h3 className={"text-[#333333] text-sm font-bold"}>
                {index + 1}. {item.title}
              </h3>
              <div className="pl-[13px]">
                <span className="text-[#333333] text-sm font-normal ">
                  {item.content}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataProtectionPolicy;
